import React from 'react';
import { Typography, TypographyProps } from '../../../../components/Typography';
import { Box } from '../../../../wag-react/next-components/box';
import { theme } from '../../../../wag-react/themes/base-theme';
export type VetChatMessageProps = {
  botName?: string;
} & TypographyProps;
export const VetChatMessage = ({
  botName = null,
  ...rest
}: VetChatMessageProps) => <>
    {botName && <Box mb={2}>
        <Typography variant="body2" fontSize="14px" fontWeight="bold">
          {botName}
        </Typography>
      </Box>}
    <Typography m={0} fontSize="16px" color={theme.colors.charcoal} {...rest} data-sentry-element="Typography" data-sentry-source-file="index.tsx" />
  </>;